// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "inner-3EZO8";
export { _1 as "__esModule", _2 as "inner" }
export default { "__esModule": _1, "inner": _2 }
